/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Criteria } from './Criteria';
import {
    CriteriaFromJSON,
    CriteriaFromJSONTyped,
    CriteriaToJSON,
    CriteriaToJSONTyped,
} from './Criteria';

/**
 * 
 * @export
 * @interface FindAllCriteria200Response
 */
export interface FindAllCriteria200Response {
    /**
     * 
     */
    data?: Array<Criteria>;
}

/**
 * Check if a given object implements the FindAllCriteria200Response interface.
 */
export function instanceOfFindAllCriteria200Response(value: object): value is FindAllCriteria200Response {
    return true;
}

export function FindAllCriteria200ResponseFromJSON(json: any): FindAllCriteria200Response {
    return FindAllCriteria200ResponseFromJSONTyped(json, false);
}

export function FindAllCriteria200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllCriteria200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(CriteriaFromJSON)),
    };
}

export function FindAllCriteria200ResponseToJSON(json: any): FindAllCriteria200Response {
    return FindAllCriteria200ResponseToJSONTyped(json, false);
}

export function FindAllCriteria200ResponseToJSONTyped(value?: FindAllCriteria200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(CriteriaToJSON)),
    };
}

